'use client'

import { useState } from 'react'
import { cn } from '@segway/core'

import { Select as SelectUI, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/ui'

interface SelectOptions {
  label: string
  value: string
}

interface SelectProps {
  options: SelectOptions[]
  className?: string
  placeholder?: string
  type?: string
  onValueChange: (val: string) => void
  value?: string | undefined
  defaultValue?: string | undefined
  iconClassName?: string
  itemClassName?: string
  contentClassName?: string
}

const Select: React.FC<SelectProps> = ({
  options,
  className,
  placeholder,
  type,
  value,
  onValueChange,
  defaultValue,
  iconClassName,
  itemClassName,
  contentClassName,
  ...props
}) => {
  const [selector, setSelector] = useState<string>(defaultValue ?? '')

  const swicthStyles = ({ type, className }: { type?: string; className?: string }) => {
    switch (type) {
      case 'noBorder':
        return cn('w-auto border-0 focus:ring-0 [&>span]:mr-7', className)
      default:
        return cn('w-[180px]', className)
    }
  }

  return (
    <>
      {options && options.length > 0 && (
        <SelectUI
          onValueChange={(value) => {
            onValueChange(value)
            setSelector(value)
          }}
          defaultValue={defaultValue}
          value={value}
          {...props}>
          <SelectTrigger
            className={swicthStyles({ type, className })}
            iconClassName={iconClassName}>
            <SelectValue placeholder={placeholder || ''} />
          </SelectTrigger>
          <SelectContent className={contentClassName}>
            {options.map((item, index) => (
              <SelectItem
                className={cn(
                  'cursor-pointer bg-transparent text-lg text-black hover:text-red-400',
                  itemClassName,
                  selector === item.value
                    ? 'font-miSansDemiBold450 text-primary focus:text-primary'
                    : '',
                  index === options.length - 1 ? 'border-b-0' : '',
                )}
                key={item.value}
                value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </SelectContent>
        </SelectUI>
      )}
    </>
  )
}

export default Select
